document.addEventListener('DOMContentLoaded', function() {
    const currentPath = window.location.pathname;
    const menuItems = document.querySelectorAll('.header__menu-item');

    menuItems.forEach(item => {
        const itemHref = new URL(item.href, window.location.origin).pathname;

        if (itemHref === currentPath) {
            const span = item.querySelector('span');

            if (span) {
                span.classList.add('header__active-menu-item');
            }

            menuItems.forEach(otherItem => {
                if (otherItem !== item) {
                    const otherSpan = otherItem.querySelector('span');
                    if (otherSpan) {
                        otherSpan.classList.remove('header__active-menu-item');
                    }
                }
            });
        }
    });

    // Dae Waitlist
    const waitlistDiv = document.getElementById('dae-waitlist');

    if (waitlistDiv) {
        const waitlistBtn = waitlistDiv.querySelector('#dae-waitlist-btn');
        const waitlistForm = waitlistDiv.querySelector('#dae-waitlist-form');

        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const productFormBtns = document.querySelector('.product-form__buttons');
            waitlistForm.querySelector('input[name="contact[note]"]').value = event.data.variant.name;

            if (event.data.variant.available) {
                waitlistDiv.style.display = 'none';
                productFormBtns.style.display = 'block';
            } else {
                waitlistDiv.style.display = 'block';
                productFormBtns.style.display = 'none';
            }
        });

        waitlistBtn.addEventListener('click', () => {
            const userEmail = prompt('Please enter your email:');

            if (userEmail) {
                waitlistForm.querySelector('input[name="contact[email]"]').value = userEmail;
                waitlistForm.submit();
            }
        });

        if (window.location.href.endsWith("?customer_posted=true#ContactFooter")) {
            alert('Thanks for subscribing!');
        }
    }
});
